import React from "react";
import { useEffect } from "react";

export function useScrollToBottomWhileStreaming(targetElementRef: React.RefObject<HTMLElement>, isStreaming: boolean) {
    return useEffect(() => {
        if (!isStreaming) {
            return;
        }
        const scroll = () => {
            if (targetElementRef.current) {
                targetElementRef.current.scrollTo({ top: targetElementRef.current.scrollHeight, behavior: "smooth" });
            }
        };
        const to = setInterval(scroll, 250);
        return () => {
            clearInterval(to);
            setTimeout(scroll, 100); // final scroll after streaming ends
        };
    }, [isStreaming]);
}
